import $ from 'jquery';

const $questionTemplate = $( '#product-detail__question' );
const $container = $( '.question__container' );
const $wrapper = $( '.question__wrapper' );
let hasForm = false;

$wrapper.on( 'click', (e) => {
	hasForm = true;
} )

$container.on( 'click', (e) => {
	const target = $(e.currentTarget);

	if ( hasForm ) {
		hasForm = false;
		return;
	}

	target.toggleClass( 'question__container--open' );
	window.scrollTo($questionTemplate);
} );

const $askAQuestionButton = $( '#open-ask-a-question' );

$askAQuestionButton.on('click', () => {
	$container.addClass('question__container--open')
	window.scrollTo($questionTemplate);
});